import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Carhireforoutstationinmumbai() {



  const cardData =
  {
    keyword: 'Car Hire for Outstation in Mumbai ',
    heading: 'Shambhu Cabs: Car Hire for Outstation in Mumbai',
    headingDescription: 'Shambhu Cabs offers dependable Car Hire for Outstation in Mumbai, providing safe, comfortable, and hassle-free travel for families, tourists, corporate travelers, and groups heading to destinations like Pune, Mahabaleshwar, Lonavala, Shirdi, Nashik, Goa, and beyond. Our fleet of well-maintained hatchbacks, sedans, SUVs, luxury cars, and tempo travellers ensures a smooth and enjoyable journey with spacious seating and clean interiors. With flexible one-way and round-trip options, experienced chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes intercity travel convenient, seamless, and reliable. For comfort, safety, and a trusted outstation travel experience, Shambhu Cabs is your preferred choice for car hire for outstation in Mumbai.',

    top: 'Top Places to Visit in Mumbai Outstation with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located just 85 km from Mumbai, Lonavala and Khandala are the most popular outstation hill stations known for misty mountains, lush valleys, waterfalls, and scenic viewpoints. Tiger Point, Bhushi Dam, Lion’s Point, Rajmachi Fort, and Pawna Lake are top attractions. A perfect weekend escape for families, friends, and couples looking for fresh air and greenery."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Mahabaleshwar is Maharashtra’s most scenic hill station, famous for strawberry farms, Venna Lake, Mapro Garden, Arthur’s Seat, and Wilson Point. Panchgani offers beautiful viewpoints like Table Land and Sydney Point. A Mumbai–Mahabaleshwar outstation cab trip is ideal for a 2–3 day relaxing getaway in cool weather."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa is a peaceful, European-style private hill city near Pune featuring lakeside promenades, colorful buildings, adventure activities, cafes, and photography spots. It’s perfect for outings, romantic trips, and weekend holidays from Mumbai."
  },
  {
    "title": "Nashik",
    "description": "One of India’s oldest and holiest cities, Nashik is known for Sula Vineyards, Trimbakeshwar Jyotirlinga, Panchavati, Ramkund, and scenic surroundings. Wine lovers, pilgrims, and nature enthusiasts often book Mumbai–Nashik outstation cabs for one-day or two-day trips."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is India’s most visited spiritual destination and home to Shri Sai Baba Temple. Millions of devotees visit every year for darshan, meditation, and blessings. The town also features Shani Shingnapur nearby, making Mumbai–Shirdi outstation trips highly popular."
  },
  {
    "title": "Alibaug",
    "description": "A coastal paradise just 95 km from Mumbai, Alibaug offers clean beaches, sea forts, water sports, cafes, and peaceful stays. Popular spots include Alibaug Beach, Varsoli Beach, Nagaon, Murud-Janjira, and Kashid Beach. Ideal for beach holidays, photoshoots, and weekend road trips."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a beautiful hill destination known for the Vipassana International Academy, Bhatsa River Valley, Camel Valley, Kalsubai Peak, and ancient forts. Its pleasant climate, greenery, and trekking trails make it an excellent outstation choice from Mumbai."
  },
  {
    "title": "Kolad",
    "description": "Kolad is the adventure capital of Maharashtra, famous for Kundalika River White Water Rafting, camping, kayaking, and zip-lining. It’s a top choice for adventure groups booking outstation cab services from Mumbai."
  },
  {
    "title": "Daman & Silvassa",
    "description": "Daman offers clean beaches, Portuguese colonial forts, churches, and seaside resorts. Silvassa, the capital of Dadra & Nagar Haveli, features wildlife parks, tribal museums, lakes, and serene forests. Both destinations are perfect for calm and budget-friendly weekend outings from Mumbai."
  },
  {
    "title": "Pune",
    "description": "Pune is a major cultural and IT hub known for historical monuments, hill viewpoints, shopping, nightlife, and gardens. Popular attractions include Aga Khan Palace, Shaniwar Wada, Saras Baug, Sinhagad Fort, and shopping streets. Mumbai–Pune outstation cabs are frequently booked for business trips, travel, and leisure."
  },
  {
    "title": "Matheran",
    "description": "Asia’s only vehicle-free hill station, Matheran offers untouched forests, toy train rides, and 30+ viewpoints like Echo Point, Louisa Point, and Charlotte Lake. It provides a peaceful, pollution-free escape from Mumbai’s rush."
  },
  {
    "title": "Saputara",
    "description": "Situated on the Maharashtra–Gujarat border, Saputara is a scenic hill station known for its cool weather, boating lake, Gira Waterfalls, step gardens, and tribal culture. It's ideal for a long weekend outstation trip from Mumbai."
  }
],



"services": [
  {
    "name": "Outstation Car Rental Mumbai",
    "description": "Outstation Car Rental Mumbai offers dependable, comfortable, and professionally managed car rental services for long-distance travel from Mumbai to destinations across India. Travellers can choose from sedans, SUVs, luxury vehicles, and family cars based on their journey needs. Every car comes with a trained chauffeur, clean interiors, AC comfort, and verified safety standards. Perfect for business trips, holidays, temple tours, medical visits, and multi-day city-to-city travel, this service provides transparent pricing, doorstep pickup, and round-the-clock support to ensure smooth and enjoyable journeys."
  },
  {
    "name": "Outstation Car Hire Near Me",
    "description": "Outstation Car Hire Near Me provides quick access to reliable cars for intercity travel with immediate or scheduled booking options. Customers get access to nearest available vehicles, ensuring minimal waiting time and maximum convenience. Ideal for last-minute plans, urgent outstation requirements, and planned long trips, this service guarantees clean AC cars, experienced drivers, timely pickups, and budget-friendly fares."
  },
  {
    "name": "Mumbai Outstation Car Hire",
    "description": "Mumbai Outstation Car Hire is designed for customers seeking comfortable chauffeur-driven cars for travel from Mumbai to popular destinations like Pune, Goa, Nashik, Lonavala, Surat, Ahmedabad, Shirdi, Mahabaleshwar, and more. The service includes flexible one-way, round-trip, and multi-city options, with 24×7 availability, professional drivers, clean cars, and smooth highway travel ensuring reliability and comfort."
  },
  {
    "name": "Sedan Outstation Car",
    "description": "Sedan Outstation Car service provides economical, comfortable, and smooth-ride sedans ideal for long-distance travel. With spacious seating, AC comfort, fuel efficiency, and professional drivers, it is perfect for small families, couples, executives, and frequent travellers. Sedans ensure a stable highway experience and smooth ride quality, making them a preferred choice for outstation journeys."
  },
  {
    "name": "SUV Outstation Car Mumbai",
    "description": "SUV Outstation Car Mumbai offers spacious and powerful SUV vehicles like Ertiga, Innova, and Crysta for extra comfort during long trips. Ideal for families, groups, and travellers carrying heavy luggage, SUVs provide superior stability, high seating comfort, extra legroom, and smooth performance even on hilly or rough terrains. This service ensures a relaxed and premium travel experience for long journeys across states."
  },
  {
    "name": "Affordable Outstation Car Hire",
    "description": "Affordable Outstation Car Hire delivers value-for-money intercity travel solutions with transparent pricing, economical fuel-efficient cars, and zero hidden charges. Ideal for budget-conscious travellers, students, solo riders, and frequent outstation commuters, this service ensures comfort, cleanliness, safety, and reliability at the lowest possible fares while maintaining high service quality."
  },
  {
    "name": "Long Distance Car Hire Mumbai",
    "description": "Long Distance Car Hire Mumbai specializes in long-route travel with experienced long-distance chauffeurs, well-maintained vehicles, and safe highway driving practices. Perfect for multi-hour trips, interstate journeys, pilgrimage routes, and extended holiday tours, this service ensures smooth, fatigue-free travel, planned rest stops, and timely arrival at your destination."
  },
  {
    "name": "Airport Outstation Car",
    "description": "Airport Outstation Car offers convenient pickup from Mumbai Airport (T1/T2) for travellers heading directly to outstation destinations. This service includes flight tracking, on-time pickups, clean AC cars, courteous drivers, and luggage assistance. Ideal for families, NRIs, foreign travellers, and corporate clients needing smooth airport-to-city transfers without delays."
  },
  {
    "name": "Corporate Outstation Car Mumbai",
    "description": "Corporate Outstation Car Mumbai provides professional intercity transportation for business travellers, client visits, company events, and executive transfers. Features include premium sedans/SUVs, uniformed chauffeurs, punctual service, invoicing support, comfortable seating, and safe long-distance travel. Tailored for companies requiring reliable travel solutions at scale."
  },
  {
    "name": "Luxury Outstation Car Hire Mumbai",
    "description": "Luxury Outstation Car Hire Mumbai offers high-end vehicles such as Mercedes, BMW, Audi, Camry, and luxury SUVs for premium long-distance journeys. Ideal for VIP guests, corporate executives, weddings, special occasions, and luxury holiday trips, this service ensures top-tier comfort, privacy, safety, and five-star travel experience with professional chauffeurs."
  },
  {
    "name": "24×7 Outstation Car Booking",
    "description": "24×7 Outstation Car Booking provides round-the-clock availability for urgent trips, late-night departures, early morning rides, and planned outstation journeys. With instant booking confirmation, fast dispatch, and reliable drivers, this service ensures safe and hassle-free travel at any hour of the day or night."
  },
  {
    "name": "Family Outstation Car Rental",
    "description": "Family Outstation Car Rental offers spacious, comfortable, and family-friendly vehicles designed for long holidays, weekend getaways, road trips, and pilgrimages. Cars come with ample luggage space, clean interiors, AC comfort, safety features, child-friendly arrangements, and courteous drivers to ensure a pleasant family travel experience."
  },
  {
    "name": "Best Outstation Car Hire Mumbai",
    "description": "Best Outstation Car Hire Mumbai ensures premium quality vehicles, verified chauffeurs, GPS safety, guaranteed punctuality, and smooth expressway rides. Ideal for customers seeking the highest level of service along with complete reliability, comfort, and professional travel management."
  },
  {
    "name": "Car for Outstation Travel Mumbai",
    "description": "Car for Outstation Travel Mumbai provides customized trip planning, route guidance, flexible travel schedules, and comfortable cars for any long-distance destination. Suitable for vacations, temple yatras, business tours, weddings, or personal travel, this service ensures a stress-free travel experience with trained drivers and clean vehicles."
  },
  {
    "name": "Online Outstation Car Hire",
    "description": "Online Outstation Car Hire allows customers to instantly book cars digitally with live fare quotes, vehicle selection, secure online payment, and automated confirmations. Ideal for travelers who prefer fast, simple, and transparent booking processes with flexible trip options."
  },
  {
    "name": "Fast Outstation Car Hire Mumbai",
    "description": "Fast Outstation Car Hire Mumbai offers quick dispatch of vehicles, express booking support, and minimal waiting time for immediate intercity travel needs. Perfect for emergencies, urgent meetings, last-minute travel, and time-sensitive routes requiring fast and reliable service."
  },
  {
    "name": "Safe Car Hire Mumbai",
    "description": "Safe Car Hire Mumbai prioritizes safety with sanitized cars, verified chauffeurs, GPS tracking, careful driving, and strict safety protocols. Ideal for families, senior citizens, solo female travellers, night journeys, and long-route travel requiring maximum protection and reliability."
  }
],

"tableData": [
  ["Outstation Car Rental Mumbai", "Outstation Car Hire Near Me"],
  ["Mumbai Outstation Car Hire", "Sedan Outstation Car"],
  ["SUV Outstation Car Mumbai", "Affordable Outstation Car Hire"],
  ["Long Distance Car Hire Mumbai", "Airport Outstation Car"],
  ["Corporate Outstation Car Mumbai", "Luxury Outstation Car Hire Mumbai"],
  ["24×7 Outstation Car Booking", "Family Outstation Car Rental"],
  ["Best Outstation Car Hire Mumbai", "Car for Outstation Travel Mumbai"],
  ["Online Outstation Car Hire", "Fast Outstation Car Hire Mumbai"],
  ["Safe Car Hire Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Car Hire for Outstation in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable car hire services for outstation travel from Mumbai, ideal for weekend getaways, long trips, and family vacations."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cars",
    "WhyChoosedescription": "Travel in clean, spacious, air-conditioned, and regularly serviced cars to enjoy a smooth and comfortable outstation journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long-Distance Travel",
    "WhyChoosedescription": "Our expert drivers are familiar with major outstation routes from Mumbai, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent and Budget-Friendly Pricing",
    "WhyChoosedescription": "We offer clear pricing with no hidden charges—fuel, tolls, and driver allowances included for your outstation car hire."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to help with bookings, travel plans, and route assistance."
  },
  {
    "WhyChooseheading": "Flexible Outstation Trip Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized outstation car hire packages tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Sanitized and Safe Vehicles",
    "WhyChoosedescription": "All cars are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Pickup Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your outstation travel from Mumbai smooth and stress-free."
  }
]






















  }

const faqData = [
  {
    question: 'Can I hire a car for outstation travel from Mumbai with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers car hire services for outstation travel from Mumbai to various destinations across India, providing a comfortable and reliable journey.',
  },
  {
    question: 'How can I hire a car for outstation travel from Mumbai?',
    answer: 'You can hire a car easily through our website, mobile app, or by contacting our 24x7 customer support team to book your outstation journey.',
  },
  {
    question: 'What types of cars are available for outstation hire from Mumbai?',
    answer: 'Shambhu Cabs offers a variety of cars for outstation hire, including sedans, SUVs, luxury cars, and even Tempo Travellers for group travel.',
  },
  {
    question: 'Are drivers experienced for outstation car hire services from Mumbai?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with long-distance routes to ensure a safe and smooth journey to your outstation destination.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my outstation car hire?',
    answer: 'Yes, you can select any pickup and drop-off points in Mumbai and at your outstation destination, making the trip as convenient as possible.',
  },
  {
    question: 'Is outstation car hire available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers 24x7 outstation car hire services, allowing you to travel at any time that suits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for outstation car hire from Mumbai?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers adhere to strict safety and hygiene guidelines to ensure a safe and comfortable journey.',
  },
  {
    question: 'What payment options are available for outstation car hire in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for outstation car hire bookings.',
  },
  {
    question: 'Is customer support available during my outstation car hire journey from Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your outstation car hire journey from Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Gupta',
    feedback: 'We hired a car from Shambhu Cabs for our outstation trip from Mumbai. The service was excellent, the driver was professional, and the car was comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Desai',
    feedback: 'Highly recommend Shambhu Cabs for outstation car hire in Mumbai. Smooth booking process, excellent customer service, and a safe, comfortable journey.',
    rating: 5,
  },
];





































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Hire for Outstation in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/outstation-car-rental-mumbai.jpg",
  "description": "Book reliable outstation car hire in Mumbai with Shambhu Cabs. We provide sedans, SUVs, and luxury cars for long-distance travel, corporate trips, family journeys, and airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "920",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/outstation-car-hire-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Car Hire for Outstation in Mumbai | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book outstation car hire in Mumbai with Shambhu Cabs. Sedans, SUVs, and luxury cars available for long-distance travel, family trips, corporate travel, and airport transfers."
  />

  <meta
    name="keywords"
    content="Outstation Car Rental Mumbai, Outstation Car Hire Near Me, Mumbai Outstation Car Hire, Sedan Outstation Car, SUV Outstation Car Mumbai, Affordable Outstation Car Hire, Long Distance Car Hire Mumbai, Airport Outstation Car, Corporate Outstation Car Mumbai, Luxury Outstation Car Hire Mumbai, 24×7 Outstation Car Booking, Family Outstation Car Rental, Best Outstation Car Hire Mumbai, Car for Outstation Travel Mumbai, Online Outstation Car Hire, Fast Outstation Car Hire Mumbai, Safe Car Hire Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Carhireforoutstationinmumbai;